import React from "react";
import ReportsItemLink from "./reports-item-link.jsx";

export default class ReportsItem extends React.Component {
    constructor(props) {
        super(props);

        this.generateContent = this.generateContent.bind(this);
        this.generateLink = this.generateLink.bind(this);
        this.onItemSelected = this.onItemSelected.bind(this);
    }

    generateLink() {
        return <ReportsItemLink key={this.props.text} url={this.props.url} text={this.props.text} />;
    }

    generateContent() {
        var content = [this.generateLink()];
        return content;
    }

    onItemSelected() {
        if (this.props.onClick)
            this.props.onClick(this.props.text, this.props.parameters);
    }

    render() {
        var content = this.generateContent();
        return (
            <li onClick={this.onItemSelected}>
                {content}
            </li>
        );
    }
}